import React from 'react';
import Card from '../Card';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';
import Icon from '../Icon';

interface IconRadioItemProps {
    value: string | number;
    label: string;
    icon: string;
    iconStyle?: React.CSSProperties;
    description?: string;
    selected?: boolean;
    error?: boolean;
    disabled?: boolean;
}

const IconRadioItem = (props: IconRadioItemProps) => {
    const {
        value,
        label,
        icon,
        iconStyle,
        description,
        selected,
        error,
        disabled,
    } = props;
    return (
        <Card
            style={{
                width: '120px',
                borderColor: selected
                    ? 'var(--primary-400)'
                    : error
                    ? 'var(--error-400)'
                    : 'var(--border)',
                background: selected ? 'var(--white)' : 'transparent',
            }}
        >
            <FormControlLabel
                value={value}
                disabled={disabled}
                sx={{
                    m: 0,
                    width: 120,
                    alignItems: 'stretch',
                    position: 'relative',
                    '.MuiFormControlLabel-label': {
                        width: '100%',
                    },
                }}
                label={
                    <Box
                        sx={{
                            width: '100%',
                            padding: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                height: 35,
                                borderRadius: 2,
                                display: 'grid',
                                placeItems: 'center',
                            }}
                        >
                            <Icon
                                iconName={icon}
                                fontSize='large'
                                style={iconStyle}
                            />
                        </Box>

                        <Typography sx={{ textAlign: 'center' }}>
                            {label}
                        </Typography>
                        {description && (
                            <Typography variant='body2' color='text.secondary'>
                                {description}
                            </Typography>
                        )}
                    </Box>
                }
                control={
                    <Radio
                        size='small'
                        sx={{
                            p: 0,
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            '& .MuiSvgIcon-root': {
                                fontSize: 16,
                            },
                        }}
                    />
                }
            />
        </Card>
    );
};

export default IconRadioItem;
